import { useNavigate, useParams } from "react-router-dom"
import { useContext, useEffect, useState } from 'react'
import moment from 'moment'
import OrganisationService from '../../../../shared/services/organisation/organisation.service'
import { UserDetailsContext } from '../../../../context/user-details/user-details'
import { UserNotificationsContext } from '../../../../context/user-notifications/user-notifications'
import { ReportPeriodContext } from '../../../../context/report-periods/report-periods'
import VehicleService from '../../../../shared/services/vehicle/vehicle.service'
import LocationService from '../../../../shared/services/location/location.service'
import GroupService from '../../../../shared/services/group/group.service'
import SuperAdminService from '../../../../shared/services/super-admin/super-admin.service'
import { IOrganisationDetails } from '../../../../shared/services/organisation/organisation.model'
import { IHeadCell } from '../../../../shared/interfaces/table-display.model'
import { PageOuterContainer } from '../../../../root-components/layouts/page-outer-container'
import { PageHeading } from '../../../presentation-components/display-elements-components/page-heading'
import { IconName } from '../../../../shared/interfaces/icon-picker.model'
import { Box, Button, Checkbox, Chip, FormControlLabel, IconButton, Stack, Tab, Tabs, ToggleButton, ToggleButtonGroup, Typography, useMediaQuery } from '@mui/material'
import { a11yProps } from '../../../../shared/utils/misc-shared-utils'
import { CustomTabPanel } from '../../../presentation-components/display-elements-components/custom-tab-panel'
import { ShallowFormDisplay } from '../../../presentation-components/form-field-components/general/shallow-form-display'
import { FormTextInputDisplay } from '../../../presentation-components/form-field-components/new-and-edit/form-text-input'
import { CancelOutlined, CheckOutlined, HideSourceOutlined, MailOutlineOutlined } from '@mui/icons-material'
import { TableDisplay } from '../../../presentation-components/miscellaneous-components/table-display'
import { IUserDetails } from '../../../../shared/services/user-details/user-details.model'
import gaiaTheme from '../../../../root-components/theme'
import SubsidiaryService from '../../../../shared/services/subsidiary/subsidiary.service'
import ProjectService from '../../../../shared/services/project/project.service'
import ContactSupplierService from '../../../../shared/services/contact-supplier/contact-supplier.service'

export const SuperAdminOrganisationPage = () => {
  const navigate = useNavigate()
  const { id } = useParams()
  //Services
  const organisationService = new OrganisationService()
  const userDetailsContext = useContext(UserDetailsContext)
  const userNotificationsContext = useContext(UserNotificationsContext)
  const reportPeriodContext = useContext(ReportPeriodContext)
  const vehicleService = VehicleService.getInstance();
  const locationService = LocationService.getInstance();
  const groupService = GroupService.getInstance();
  const superAdminService = new SuperAdminService()
  const subsidiaryService = SubsidiaryService.getInstance()
  const projectService = ProjectService.getInstance()
  const contactSupplierService = ContactSupplierService.getInstance()
  //State
  const [organisation, setOrganisation] = useState<IOrganisationDetails>()
  const [originalOrganisation, setOriginalOrganisation] = useState<IOrganisationDetails>()
  const [value, setValue] = useState(0);
  const [editField, setEditField] = useState<string>('')
  const [freeTrialDaysGrantedDraft, setFreeTrialDaysGrantedDraft] = useState<string | undefined>(undefined)
  const [customDomainUrlDraft, setCustomDomainUrlDraft] = useState<string | undefined>(undefined)
  const [partnerFromEmailAddressDraft, setPartnerFromEmailAddressDraft] = useState<string | undefined>(undefined)
  const [aiCopilotMonthlyLimitDraft, setAiCopilotMonthlyLimitDraft] = useState<string | undefined>(undefined)
  const [partnerClients, setPartnerClients] = useState<IOrganisationDetails[]>([])
  const [clientStatus, setClientStatus] = useState<any>()
  const [users, setUsers] = useState<IUserDetails[]>([])
  const [paramString, setParamString] = useState<string>('active');
  //Table State
  const [selected, setSelected] = useState<string[]>([]);
  const [inputPage, setInputPage] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0)
  const [perPage, setPerPage] = useState(10)
  const [change, setChange] = useState<number>(0)
  const [orderBy, setOrderBy] = useState<string>()
  const [order, setOrder] = useState<'asc' | 'desc'>()
  //Loading State
  const [hasPageMounted, setHasPageMounted] = useState<boolean>(false)
  //Layout
  const isMobileMode = useMediaQuery(gaiaTheme.breakpoints.down('md'));
  //Use Effects
  useEffect(() => {
    if (value === 0) {
      getOrganisation()
    } else if (value === 1) {
      getPartnerClients()
      checkClientStatus()
    } else if (value === 2) {
      getUsers()
    }
  }, [id, inputPage, perPage, change])

  useEffect(() => {
    if (hasPageMounted) {
      if (inputPage === 0) {
        setChange(change + 1)
      } else {
        setInputPage(0)
      }
    }
    setHasPageMounted(true)
  }, [value, order, orderBy, paramString])

  const getOrganisation = () => {
    if (id) {
      organisationService.getOne(id)
        .then(response => {
          setOrganisation(response)
          setOriginalOrganisation(response)
        })
    }
  }

  const getPartnerClients = () => {
    if (id) {
      superAdminService.getPartnerClientsWithPagination(id, inputPage, perPage, orderBy, order)
        .then(response => {
          setPartnerClients(response.rows)
          setTotalRecords(response.count)
        })
        .catch(err => {
          console.log(err)
        })
    }
  }

  const getUsers = () => {
    if (id) {
      superAdminService.getAllUserDetailsWithPagination(id, paramString, inputPage, perPage, orderBy, order, '&getLastLoggedIn=true')
        .then(response => {
          setUsers(response.rows)
          setTotalRecords(response.count)
        })
        .catch(err => {
          console.log(err)
        })
    }
  }

  const checkClientStatus = () => {
    if (id) {
      superAdminService.checkClientStatus(id)
        .then(response => {
          setClientStatus(response)
        })
        .catch(err => {
          console.log(err)
        })
    }
  }

  //Partner Table Contents
  const headCells: IHeadCell[] = [
    { id: 'name', numeric: false, label: 'Client Name', sortable: false, isHeading: true },
  ];

  const rows = partnerClients.map(client => {
    return { id: client.id, name: client.name }
  });

  //User Table Contents
  const userHeadCells: IHeadCell[] = [
    { id: 'name', numeric: false, label: 'User Name', sortable: false, isHeading: true },
    { id: 'email', numeric: false, label: 'Email', sortable: true },
    // { id: 'createdAt', numeric: false, label: 'Created on', sortable: true },
    ...(paramString === 'active' ? [{ id: 'lastLogin', numeric: false, label: 'Last Login At', sortable: true }] : []),
  ];

  const userRows = !users ? [] : users.map(user => {
    return {
      id: user.id,
      name: user.firstName + ' ' + user.surname,
      email: <Stack direction='row' alignItems='center' spacing={1}>
        {user.email}
        <IconButton onClick={() => window.open(`mailto:${user.email}`, '_blank')}><MailOutlineOutlined /></IconButton>
      </Stack>,
      createdAt: moment(user.createdAt).format('DD/MM/YYYY HH:mm'),
      lastLogin: user.lastLogin ? moment(user.lastLogin).format('DD/MM/YYYY HH:mm') : null,
    }
  });

  //Component Event Handlers
  const connectionHandler = (organisationId: string) => {
    if (!userDetailsContext.userDetails?.isLoggedInAsCustomer) {
      reportPeriodContext.clearData();
      vehicleService.clearData();
      groupService.clearData();
      locationService.clearData();
      superAdminService.joinUserOrganisation(organisationId)
        .then(() => {
          userDetailsContext.forceUpdateUserDetails()
            .then(() => {
              locationService.clearData()
              vehicleService.clearData()
              subsidiaryService.clearData()
              projectService.clearData()
              contactSupplierService.clearData()
              return reportPeriodContext.forceUpdateReportPeriods()
            })
            .then(() => {
              navigate('/dashboard')
            })
        })
        .catch(err => {
          console.log(err)
          userNotificationsContext.openSnackbar({ open: true, message: 'There was an error, please try again', backgroundColor: 'text.primary' });
        })
    }
  }

  const subscriptionHandler = () => {
    userNotificationsContext.openDialog({
      active: true,
      title: 'Confirmation',
      message: `Are you sure you want to ${organisation?.subscriptionActive ? 'deactivate' : 'activate'} the subscription for this organisation?`,
      buttonCopy: 'Continue', cancelButtonCopy: 'Cancel'
    })
      .then(response => {
        if (response) {
          superAdminService.toggleSubscription(id!)
            .then(response => {
              getOrganisation()
              userDetailsContext.forceUpdateUserDetails();
              userNotificationsContext.openSnackbar({ open: true, message: 'Updated successfully' });
            })
            .catch(err => {
              userNotificationsContext.openSnackbar({ open: true, message: 'There was an error, please try again', backgroundColor: 'text.primary' });
              console.log(err)
            })
        }
      })
  }

  const apiAccessHandler = () => {
    if (!id) return
    superAdminService.toggleAllowApiAccess(id)
      .then(() => {
        getOrganisation()
        userNotificationsContext.openSnackbar({ open: true, message: 'Updated successfully' });
      })
      .catch(err => {
        userNotificationsContext.openSnackbar({ open: true, message: 'There was an error, please try again', backgroundColor: 'text.primary' });
        console.log(err)
      })
  }

  const aiCopilotToggleHandler = () => {
    if (!id) return
    superAdminService.toggleAiCopilotEnabled(id)
      .then(() => {
        getOrganisation()
        userNotificationsContext.openSnackbar({ open: true, message: 'Updated successfully' });
      })
      .catch(err => {
        userNotificationsContext.openSnackbar({ open: true, message: 'There was an error, please try again', backgroundColor: 'text.primary' });
        console.log(err)
      })
  }

  const partnerHandler = () => {
    userNotificationsContext.openDialog({
      active: true,
      title: 'Confirmation',
      message: `Are you sure you want to ${organisation?.isPartner ? 'deactivate' : 'activate'} the partner status for this organisation?`,
      buttonCopy: 'Continue', cancelButtonCopy: 'Cancel'
    })
      .then(response => {
        if (response) {
          superAdminService.togglePartner(id!)
            .then(response => {
              getOrganisation()
              userDetailsContext.forceUpdateUserDetails();
              userNotificationsContext.openSnackbar({ open: true, message: 'Updated successfully' });
            })
            .catch(err => {
              userNotificationsContext.openSnackbar({ open: true, message: 'There was an error, please try again', backgroundColor: 'text.primary' });
              console.log(err)
            })
        }
      })
  }

  const onChangeFreeTrialDays = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    if (/^\d*$/.test(value)) {
      setFreeTrialDaysGrantedDraft(value)
    }
  }

  const onChangeCustomDomainUrl = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    setCustomDomainUrlDraft(value)
  }

  const onChangePartnerFromEmailAddress = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    setPartnerFromEmailAddressDraft(value)
  }

  const onChangeAiCopilotMonthlyLimit = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    if (/^\d*$/.test(value)) {
      setAiCopilotMonthlyLimitDraft(value)
    }
  }

  const cancelEditHandler = () => {
    if (originalOrganisation) {
      setOrganisation(originalOrganisation)
    }
    setEditField('')
    setFreeTrialDaysGrantedDraft(undefined)
    setCustomDomainUrlDraft(undefined)
    setPartnerFromEmailAddressDraft(undefined)
    setAiCopilotMonthlyLimitDraft(undefined)
  }

  const submitEditOrganisation = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    if (!organisation) return
    const updated: IOrganisationDetails = {
      ...organisation,
      ...(editField === 'customDomainUrl' ? { customDomainUrl: typeof customDomainUrlDraft !== 'undefined' ? customDomainUrlDraft : (organisation.customDomainUrl ?? '') } : {}),
      ...(editField === 'partnerFromEmailAddress' ? { partnerFromEmailAddress: typeof partnerFromEmailAddressDraft !== 'undefined' ? partnerFromEmailAddressDraft : (organisation.partnerFromEmailAddress ?? '') } : {}),
      ...(typeof freeTrialDaysGrantedDraft !== 'undefined' ? { freeTrialDaysGranted: freeTrialDaysGrantedDraft === '' ? 0 : Number(freeTrialDaysGrantedDraft) } : {}),
      ...(editField === 'aiCopilotMonthlyLimit' && typeof aiCopilotMonthlyLimitDraft !== 'undefined'
        ? {
          aiCopilotMonthlyLimit:
            aiCopilotMonthlyLimitDraft === ''
              ? null
              : Number(aiCopilotMonthlyLimitDraft),
        }
        : {}),
    }
    superAdminService.editOrganisation(organisation.id!, updated)
      .then(response => {
        setOrganisation(response)
        setOriginalOrganisation(response)
        setEditField('')
        userNotificationsContext.openSnackbar({ open: true, message: 'Updated successfully' });
      })
      .catch(err => {
        console.log(err)
        userNotificationsContext.openSnackbar({ open: true, message: 'There was an error, please try again', backgroundColor: 'text.primary' });
      })
  }

  // Table Event Handlers
  const handleOrderChange = (orderBy: string, order: 'asc' | 'desc',) => {
    setOrderBy(orderBy)
    setOrder(order)
  };

  const toggleHandler = (e: React.MouseEvent<HTMLElement>, newTable: string | null) => {
    if (newTable !== null) {
      setParamString(newTable)
    }
  };


  return (
    <PageOuterContainer>
      {organisation &&
        <>
          <PageHeading
            hasTabs={true}
            title={organisation.name}
            includeActionButton={true}
            actionButtonIcon={IconName.Login}
            actionButtonHandler={() => connectionHandler(organisation.id!)}
            actionButtonText='Access Organisation'
            includeBackButton={true}
            backButtonLink='/super-admin/organisations'
            backButtonText='Back to organisations'
          />
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs value={value} onChange={(event, newValue) => setValue(newValue)} aria-label="basic tabs example">
              <Tab label="Subscription" {...a11yProps(0)} />
              <Tab label="Partner Status" {...a11yProps(1)} />
              <Tab label="Users" {...a11yProps(2)} />
            </Tabs>
          </Box>
          <CustomTabPanel value={value} index={0}>
            <ShallowFormDisplay name={`Subscription Status`} value={organisation.subscriptionActive ?
              <Chip label='Active' variant="outlined" color='success' sx={{ color: 'green' }} /> :
              <Chip label='Not Active' variant="outlined" color='error' sx={{ color: 'red' }} />}
              isTopRow={true}
            />
            <ShallowFormDisplay name={`Account Created`} value={moment(organisation.createdAt).format('DD/MM/YYYY')} />
            <ShallowFormDisplay
              name='Enable API Access'
              isBottomRow={false}
              value={
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={organisation.allowApiAccess ?? false}
                      onChange={apiAccessHandler}
                    />
                  }
                  label=''
                  sx={{ m: 0 }}
                />
              }
            />
            <ShallowFormDisplay
              name='Enable AI Copilot (G.A.I)'
              isBottomRow={false}
              value={
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={organisation.aiCopilotEnabled ?? false}
                      onChange={aiCopilotToggleHandler}
                    />
                  }
                  label=''
                  sx={{ m: 0 }}
                />
              }
            />
            <Box component='form' onSubmit={submitEditOrganisation}>
              <FormTextInputDisplay
                isEditPage={true}
                editField={editField}
                setEditField={setEditField}
                allowEdit={true}
                isBottomRow={!organisation.subscriptionActive ? false : true}
                isLastField={organisation.subscriptionActive ? true : false}
                disabled={editField !== 'aiCopilotMonthlyLimit'}
                title='AI Copilot monthly request cap'
                name='aiCopilotMonthlyLimit'
                value={
                  editField === 'aiCopilotMonthlyLimit'
                    ? (typeof aiCopilotMonthlyLimitDraft !== 'undefined'
                      ? aiCopilotMonthlyLimitDraft
                      : (organisation.aiCopilotMonthlyLimit != null ? String(organisation.aiCopilotMonthlyLimit) : ''))
                    : (organisation.aiCopilotMonthlyLimit != null ? organisation.aiCopilotMonthlyLimit : '')
                }
                type='number'
                onChange={onChangeAiCopilotMonthlyLimit}
                cancelEditHandler={cancelEditHandler}
                tooltip='Optional per-organisation cap over a rolling 30-day window. Leave blank for no org cap (hourly user and daily org env limits still apply).'
              />
            </Box>
            {!organisation.subscriptionActive &&
              <>
                <ShallowFormDisplay name={`Trial Status`} value={organisation.freeTrialDaysRemaining !== 0 ?
                  <Chip label='Active' variant="outlined" color='success' sx={{ color: 'green' }} /> :
                  <Chip label='Not Active' variant="outlined" color='error' sx={{ color: 'red' }} />}
                />
                <ShallowFormDisplay name={`Trial Days Remaining`} value={organisation.freeTrialDaysRemaining}
                  isBottomRow={organisation.subscriptionActive ? true : false}
                />
                <Box component='form' onSubmit={submitEditOrganisation}>
                  <FormTextInputDisplay
                    isEditPage={true}
                    editField={editField}
                    setEditField={setEditField}
                    allowEdit={true}
                    isBottomRow={true}
                    isLastField={true}
                    disabled={editField !== 'freeTrialDaysGranted'}
                    title='Trial Days Granted'
                    name='freeTrialDaysGranted'
                    value={editField === 'freeTrialDaysGranted' ? (typeof freeTrialDaysGrantedDraft !== 'undefined' ? freeTrialDaysGrantedDraft : (organisation.freeTrialDaysGranted?.toString() ?? '')) : organisation.freeTrialDaysGranted}
                    type='number'
                    onChange={onChangeFreeTrialDays}
                    cancelEditHandler={cancelEditHandler}
                  />
                </Box>
              </>}
            <Stack direction='row' justifyContent='flex-end' sx={{ mt: 4 }}>
              <Button onClick={subscriptionHandler} color={organisation.subscriptionActive ? 'error' : 'primary'}>
                {organisation.subscriptionActive ? <CancelOutlined /> : <CheckOutlined />}
                <Typography sx={{ ml: 0.5 }}>{organisation.subscriptionActive ? 'Deactivate Subscription' : 'Activate Subscription'}</Typography>
              </Button>
            </Stack>
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            <ShallowFormDisplay name={`Partner Status`} value={organisation.isPartner ?
              <Chip label='Active' variant="outlined" color='success' sx={{ color: 'green' }} /> :
              <Chip label='Not Active' variant="outlined" color='error' sx={{ color: 'red' }} />}
              isTopRow={true}
            />
            {clientStatus &&
              <ShallowFormDisplay name={`Client Status`} value={clientStatus.isClient ? `Client of ${clientStatus.partnerOrganisation.name}` : 'Not a client'}
                isBottomRow={organisation.isPartner && partnerClients ? false : true}
              />}
            {organisation.isPartner && partnerClients &&
              <>
                <Box component='form' onSubmit={submitEditOrganisation}>
                  <FormTextInputDisplay
                    isEditPage={true}
                    editField={editField}
                    setEditField={setEditField}
                    allowEdit={true}
                    disabled={editField !== 'customDomainUrl'}
                    title='Custom Domain URL'
                    name='customDomainUrl'
                    value={editField === 'customDomainUrl' ? (typeof customDomainUrlDraft !== 'undefined' ? customDomainUrlDraft : (organisation.customDomainUrl ?? '')) : (organisation.customDomainUrl ?? '')}
                    type='text'
                    onChange={onChangeCustomDomainUrl}
                    cancelEditHandler={cancelEditHandler}
                  />
                  <FormTextInputDisplay
                    isEditPage={true}
                    editField={editField}
                    setEditField={setEditField}
                    allowEdit={true}
                    isLastField={true}
                    disabled={editField !== 'partnerFromEmailAddress'}
                    title='Partner Email From Address'
                    name='partnerFromEmailAddress'
                    value={editField === 'partnerFromEmailAddress' ? (typeof partnerFromEmailAddressDraft !== 'undefined' ? partnerFromEmailAddressDraft : (organisation.partnerFromEmailAddress ?? '')) : (organisation.partnerFromEmailAddress ?? '')}
                    type='text'
                    onChange={onChangePartnerFromEmailAddress}
                    cancelEditHandler={cancelEditHandler}
                    tooltip='Used as the sender for partner-branded emails (requires Postmark sender/domain verification)'
                  />
                </Box>
                <ShallowFormDisplay name={`Number of Clients`} value={totalRecords}
                  isBottomRow={true}
                />
                <Stack sx={{ mt: 2 }}>
                  <TableDisplay
                    onOrderChange={handleOrderChange}
                    isMobileMode={isMobileMode}
                    inputPage={inputPage}
                    setInputPage={setInputPage}
                    totalRecords={totalRecords}
                    perPage={perPage}
                    setPerPage={setPerPage}
                    headCells={headCells}
                    rows={rows}
                    selectByIcon={true}
                    selected={selected}
                    setSelected={setSelected}
                  />
                </Stack>
              </>}
            <Stack direction='row' justifyContent='flex-end' sx={{ mt: 4 }}>
              <Button onClick={partnerHandler} color={organisation.isPartner ? 'error' : 'success'}>
                {organisation.isPartner ? <HideSourceOutlined /> : <CheckOutlined />}
                <Typography sx={{ ml: 0.5 }}>{organisation.isPartner ? 'Deactivate Partner Status' : 'Activate Partner Status'}</Typography>
              </Button>
            </Stack>
          </CustomTabPanel>
          <CustomTabPanel value={value} index={2}>
            <Stack flexDirection={isMobileMode ? 'column' : 'row'} justifyContent={'space-between'} sx={{ mb: isMobileMode ? 2 : 4 }}>
              <Stack sx={{ mb: isMobileMode ? 2 : 0 }}>
                <ToggleButtonGroup value={paramString} onChange={toggleHandler} exclusive aria-label='table' orientation={isMobileMode ? "vertical" : 'horizontal'}>
                  <ToggleButton value='active' aria-label='active users' sx={{ width: !isMobileMode ? '175px' : '100%', pt: 0.75, pb: 0.75 }}> <Typography variant='body1' sx={{ color: 'text.primary', textTransform: 'capitalize' }}>Active Users</Typography></ToggleButton>
                  <ToggleButton value='invited' aria-label='invited users' sx={{ width: !isMobileMode ? '175px' : '100%', pt: 0.75, pb: 0.75 }}><Typography variant='body1' sx={{ color: 'text.primary', textTransform: 'capitalize' }}>Invited Users </Typography> </ToggleButton>
                  <ToggleButton value='inactive' aria-label='deactivated users' sx={{ width: !isMobileMode ? '175px' : '100%', pt: 0.75, pb: 0.75 }}> <Typography variant='body1' sx={{ color: 'text.primary', textTransform: 'capitalize' }}> Deactivated Users</Typography> </ToggleButton>
                </ToggleButtonGroup>
              </Stack>
            </Stack >
            <TableDisplay
              onOrderChange={handleOrderChange}
              isMobileMode={isMobileMode}
              inputPage={inputPage}
              setInputPage={setInputPage}
              totalRecords={totalRecords}
              perPage={perPage}
              setPerPage={setPerPage}
              headCells={userHeadCells}
              rows={userRows}
              selectByIcon={true}
              selected={selected}
              setSelected={setSelected}
            />
          </CustomTabPanel>
        </>
      }
    </PageOuterContainer >
  )
} 